module.exports = "/_next/static/images/wallet_hidden-905acbd13c41fc6fdd00619c5403926d.svg";